import { Box } from '@chakra-ui/react';
import type { MsgPayloadType } from '@halo/chat-sdk';
import { MediaIcon, SettingIcon, ChatHeaderMediaCall, Tooltip } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface ChatPanelHeaderActionsProps {
  onMediaClick: (key: MsgPayloadType | string) => void;
  onSettingClick: () => void;
  isGroup: boolean;
  isMe: boolean;
  isCalling: boolean;
}

export const ChatPanelHeaderActions = memo(function ChatPanelHeaderActions({
  onMediaClick,
  onSettingClick,
  isGroup,
  isMe,
  isCalling,
}: ChatPanelHeaderActionsProps) {
  const { t } = useTranslation();
  return (
    <Box className="ChatPanelHeaderActions" display="flex" h="full" gap="2.5" alignItems="center">
      {!isMe && !isCalling && (
        <Tooltip
          content={t('chat.tooltipMediaCall')}
          chakraPortal={false}
          openDelay={0}
          closeDelay={0}
          showArrow={true}
        >
          <Box h="fit-content" p="1" fontSize="lg" cursor="pointer">
            <ChatHeaderMediaCall
              triggerProps={{ asChild: true }}
              isGroup={isGroup}
              onMediaClick={onMediaClick}
            >
              <MediaIcon className="shake" />
            </ChatHeaderMediaCall>
          </Box>
        </Tooltip>
      )}
      <Tooltip
        content={t('chat.tooltipSetting')}
        chakraPortal={false}
        openDelay={0}
        closeDelay={0}
        showArrow={true}
      >
        <Box h="fit-content" p="1" fontSize="lg" cursor="pointer" onClick={onSettingClick}>
          <SettingIcon className="shake" />
        </Box>
      </Tooltip>
    </Box>
  );
});
